/* eslint-disable sort-keys */
import { CFTokens } from '../../../../tokens';
export const BACKGROUND = {
    DEFAULT: CFTokens.COLOR.BACKGROUND_COOL_2,
    FOCUSED: CFTokens.COLOR.BACKGROUND_DEFAULT,
};
export const BORDER_COLOR = {
    DEFAULT: 'transparent',
    FOCUSED: CFTokens.COLOR.BORDER_STRONG,
};
export const CARET_COLOR = CFTokens.COLOR.TEXT_AND_ELEMENT_EMPHASIS;
export const ROOT_GAP = CFTokens.SPACER.C;
export const ROOT_HEIGHT = {
    SM: 40,
    MD: 48,
    LG: 56,
};
export const ROOT_PADDINGS = {
    SM: {
        EMPTY: {
            LEFT: 8,
            RIGHT: 8,
        },
        FILLED: {
            LEFT: 24,
            RIGHT: 8,
        },
        FOCUSED: {
            LEFT: 24,
            RIGHT: 8,
        },
    },
    MD: {
        EMPTY: {
            LEFT: 12,
            RIGHT: 12,
        },
        FILLED: {
            LEFT: 24,
            RIGHT: 12,
        },
        FOCUSED: {
            LEFT: 24,
            RIGHT: 12,
        },
    },
    LG: {
        EMPTY: {
            LEFT: 16,
            RIGHT: 12,
        },
        FILLED: {
            LEFT: 24,
            RIGHT: 12,
        },
        FOCUSED: {
            LEFT: 24,
            RIGHT: 12,
        },
    },
};
export const ROOT_TRANSITION_DURATION = 200;
